import React from 'react';

export default function FwAddIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-plus' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
